import { LitElement, html, css, styleMap, utils } from '@hh/global.js'

class HHStickyHeader extends LitElement {
  static properties = {
    closeWhenHidden: {
      type: String,
      attribute: 'close-when-hidden',
    },
    _state: {
      type: Number,
      state: true,
    },
    _height: {
      type: Number,
      state: true,
    },
  }

  constructor() {
    super()

    this.headerBounds = {}
    this.currentScrollTop = 0
    this.closeWhenHidden = 'hh-details-modal'

    this._state = -1

    this.doSettings = this.doSettings.bind(this)
  }

  connectedCallback() {
    super.connectedCallback()
    this.onScrollHandler = this.onScroll.bind(this)
    window.addEventListener('scroll', this.onScrollHandler)
    this.createObserver()
    setTimeout(() => {
      this.doSettings()
    }, 0)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('scroll', this.onScrollHandler)
  }

  createObserver() {
    let observer = new IntersectionObserver((entries, observer) => {
      this.headerBounds = entries[0].intersectionRect
      observer.disconnect()
    })

    observer.observe(this)
  }

  doSettings() {
    this.setSpacerHeight()
    this.setDropdownMaxHeight()
    this.setMobileMenuMaxHeight()
  }

  setSpacerHeight() {
    const promoBarEl = this.querySelector('.promo-bar')
    const announcmentBarEl = this.querySelector('hh-announcement-bar')
    const headerEl = this.querySelector('hh-header')

    const { height: promoBarHeight } = promoBarEl?.getBoundingClientRect() || { height: 0 }
    const { height: announcementBarHeight } = announcmentBarEl?.getBoundingClientRect() || { height: 0 }
    const { height: headerHeight } = headerEl?.getBoundingClientRect() || { height: 0 }

    document.documentElement.style.setProperty(
      '--hh-promo-bar-height',
      `${promoBarHeight}px`
    )

    document.documentElement.style.setProperty(
      '--hh-announcment-bar-height',
      `${announcementBarHeight}px`
    )

    document.documentElement.style.setProperty(
      '--hh-header-height',
      `${headerHeight}px`
    )

    this._state = 0

    const height = promoBarHeight + announcementBarHeight + headerHeight
    this._height = height

    document.querySelector(':root').style.setProperty(`--hh-header-height`, `${this._height}px`);

    if (this.querySelector('.spacer')) {
      this.querySelector('.spacer').style.height = `${this._height}px`
    }

  }

  setDropdownMaxHeight() {
    const dropdowns = this.querySelectorAll('.header__inline-menu .header__submenu--child')
    if (dropdowns) {
      dropdowns.forEach(dropdown => {
        dropdown.style.maxHeight = `calc( 100vh - ${this._height + 50}px )`
      })
    }
  }

  setMobileMenuMaxHeight() {
    const submenus = this.querySelectorAll('.mobile-menu__navigation .mobile-menu__submenu')
    if (submenus) {
      submenus.forEach(submenu => {
        submenu.style.top = `-${this._height - 2}px`
      })
    }
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop

    if (
      scrollTop > this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.hide.bind(this))
    } else if (
      scrollTop < this.currentScrollTop &&
      scrollTop > this.headerBounds.bottom
    ) {
      requestAnimationFrame(this.reveal.bind(this))
    } else if (scrollTop <= this.headerBounds.top) {
      requestAnimationFrame(this.reset.bind(this))
    }


    this.classList[this._state ? 'add' : 'remove']("hh-sticky-header--has-scrolled")

    this.currentScrollTop = scrollTop
  }

  hide() {
    document.body.classList.remove('sticky-header--reveal')
    if (this._state === 1) {
      return
    }

    setTimeout(() => { this._state = 1 }, 10)

    document.querySelector(':root').style.setProperty(`--hh-header-height`, `0px`);

    utils.all(this.closeWhenHidden, this.header).map((element) => {
      element.setAttribute('open', false)
    })
  }

  reveal() {
    document.body.classList.add('sticky-header--reveal')
    if (this._state === 2) {
      return
    }
    this.doSettings()

    document.querySelector(':root').style.setProperty(`--hh-header-height`, `${this._height}px`);

    setTimeout(() => { this._state = 2 }, 10)
  }

  reset() {
    this.classList.remove('hh-sticky-header--has-scrolled')
    if (this._state === 0) {
      return
    }

    this.doSettings()
    document.querySelector(':root').style.setProperty(`--hh-header-height`, `${this._height}px`);

    this._state = 0
  }

  render() {
    return html`<div
      class="container"
      style="${styleMap({
        position: this._state === -1 ? 'relative' : 'fixed',
        transform: this._state === 1 ? `translateY(-100%)` : 'translateY(0)',
      })}"
    >
      <slot></slot>
    </div>
    <div
      class="spacer"
      style="${styleMap({ height: `${this._height}px`})}"
    ></div>`
  }

  static styles = css`
    .container {
      left: 0;
      width: 100%;
      z-index: var(--hh-z-index, 100);
      transform: translateY(0);
      transition: transform var(--hh-duration, 500ms);
      background-color: var(--hh-background, transparent);
    }

    .spacer {
      position: relative;
    }
  `
}

customElements.define('hh-sticky-header', HHStickyHeader)
